import { useCallback } from 'react'
import { useLocales } from '@sevenrooms/locales'
import { Button } from '@sevenrooms/ui-kit/form'
import { Box, VStack } from '@sevenrooms/ui-kit/layout'
import { Text } from '@sevenrooms/ui-kit/typography'
import { useVenue } from '../../../hooks'
import { reservationWidgetMessages } from '../../../reservationWidgetMessages'
import { getVenuePath } from '../../WidgetContainer'

export function BookReservation() {
  const { urlKey, newResWidgetEnabled } = useVenue()
  const { formatMessage } = useLocales()

  const onBookBtnClick = useCallback(() => {
    const url = getVenuePath(newResWidgetEnabled, urlKey)
    window.open(url, '_blank')
  }, [newResWidgetEnabled, urlKey])

  return (
    <VStack spacing="m" width="100%">
      <Text textStyle="h3" data-test="reservation-status-sub-header">
        {formatMessage(reservationWidgetMessages.resCancelPageSuccessSubheader)}
      </Text>
      <Box width="227px">
        <Button variant="primary" data-test="book-button" fullWidth onClick={onBookBtnClick} isExternal>
          {formatMessage(reservationWidgetMessages.resCancelPageSuccessBookButton)}
        </Button>
      </Box>
    </VStack>
  )
}
